const parts = ['container', 'control', 'label']

const baseStyleLabel = {
  userSelect: 'none',
  _disabled: { opacity: 0.4 },
}

function baseStyleControl(props: Record<string, any>): Record<string, any> {
  const { colorScheme: c } = props

  return {
    w: '100%',
    transitionProperty: 'box-shadow',
    transitionDuration: 'normal',
    border: '1px solid',
    borderColor: 'ghost',
    color: 'inherit',

    _indeterminate: {
      bg: c,
      borderColor: c,
      color: 'white',
    },

    _disabled: {
      bg: 'quartz',
      borderColor: 'manatee',
    },

    _invalid: {
      borderColor: 'error',
    },
    borderRadius: 'full',
    _checked: {
      bg: c,
      borderColor: c,
      color: 'white',

      _disabled: {
        borderColor: 'quartz',
        bg: 'ghost',
        color: 'smoke',
      },
      _before: {
        content: `""`,
        display: 'inline-block',
        pos: 'relative',
        w: '50%',
        h: '50%',
        borderRadius: '50%',
        bg: 'currentColor',
      },
    },
  }
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const baseStyle = (props: Record<string, any>) => ({
  control: baseStyleControl(props),
  label: baseStyleLabel,
})

const sizes = {
  small: {
    control: { h: 'size-4', w: 'size-4' },
    label: { fontSize: 'font-small' },
  },
  md: {
    control: { w: 'size-4', h: 'size-4' },
    label: { fontSize: 'font-body' },
  },
  lg: {
    control: { w: 'size-5', h: 'size-5' },
    label: { fontSize: 'font-body' },
  },
  xl: {
    control: { w: 'size-5', h: 'size-5' },
    label: { fontSize: 'font-lg' },
  },
}

const defaultProps = {
  size: 'lg',
  colorScheme: 'black',
}

export const radioTheme = {
  parts,
  baseStyle,
  sizes,
  defaultProps,
}
